export function getSearchMeta(baseMeta, locationSearch) {
	const hasQueryParams =
		locationSearch && new URLSearchParams(locationSearch).toString() !== '';
	return hasQueryParams
		? { ...baseMeta, noindex: true, nofollow: true }
		: baseMeta;
}
